export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/ob-step-5.png?d8c053004b9e67f6b6bb68cbbb5f0754";